import { FC, useState, createContext } from 'react';
import { strings as strings_en_US } from 'src/locales/en_US';
import { strings as strings_pt_BR } from 'src/locales/pt_BR';

type LocalizationContext = {
  language: 'pt-BR' | 'en-US';
  toggleLanguage: () => any;
  strings: any;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocalizationContext = createContext<LocalizationContext>(
  {} as LocalizationContext
);

export const LocalizationProvider: FC = ({ children }) => {
  const [language, setLanguage] = useState<'pt-BR' | 'en-US'>('pt-BR');
  const toggleLanguage = () => {
    setLanguage(language==='pt-BR'? 'en-US': 'pt-BR');
  };

  return (
    <LocalizationContext.Provider value={{ language, toggleLanguage, strings: language==='en-US'? strings_en_US: strings_pt_BR }}>
      {children}
    </LocalizationContext.Provider>
  );
};
